import {
  AppMeSchema,
  DealershipChoiceListSchema,
  EmailCodeLoginResultSchema,
  type AppMe,
  type DealershipChoiceList,
  type EmailCodeLoginResult,
} from "@lumika/shared";
import { apiFetch } from "./client";

export const authApi = {
  me: (): Promise<AppMe> => apiFetch("/auth/me", AppMeSchema),
  logout: (): Promise<void> =>
    apiFetch("/auth/logout", AppMeSchema.optional(), { method: "POST" }) as Promise<void>,
  /** Login picker options, authorised by the short-lived choice cookie. */
  dealershipChoices: (): Promise<DealershipChoiceList> =>
    apiFetch("/auth/dealership-choices", DealershipChoiceListSchema),
  /** Complete login by picking a dealership at the picker. */
  selectDealership: (dealershipId: string): Promise<AppMe> =>
    apiFetch("/auth/select-dealership", AppMeSchema, {
      method: "POST",
      body: JSON.stringify({ dealershipId }),
    }),
  /** Switch the active session to another accessible dealership. */
  switchDealership: (dealershipId: string): Promise<AppMe> =>
    apiFetch("/auth/switch", AppMeSchema, {
      method: "POST",
      body: JSON.stringify({ dealershipId }),
    }),
  /** Request an email OTP for the given address. Always resolves (204). */
  requestEmailCode: (email: string): Promise<void> =>
    apiFetch("/auth/email-code/request", EmailCodeLoginResultSchema.optional(), {
      method: "POST",
      body: JSON.stringify({ email }),
    }) as Promise<void>,
  /** Verify the OTP. Returns kind: "session" | "choice". Throws ApiError on failure. */
  verifyEmailCode: (email: string, code: string): Promise<EmailCodeLoginResult> =>
    apiFetch("/auth/email-code/verify", EmailCodeLoginResultSchema, {
      method: "POST",
      body: JSON.stringify({ email, code }),
    }),
};
